import { BuildVersion, IEnvironment } from './environment.interface';
import buildVersion from '@env/buildVersion';

const apiUrl = 'https://api-platform.portalct.mynexuscare.com';

export const environment: IEnvironment = {
  apiUrl,
  modules: [],
  production: false,
  routes: [],
  version: buildVersion as BuildVersion,
};
